import { Flex, Text } from '@tremor/react';
import { FC, HTMLAttributes } from 'react';
import s from './ConnectionSteps.module.scss';
import { StepDoneIcon } from '@/assets';

interface Props extends HTMLAttributes<HTMLDivElement> {
  steps: readonly string[];
  currentStep: number;
}

export const ConnectionSteps: FC<Props> = ({ currentStep, steps, ...rest }) => {
  return (
    <Flex className={s.stepsWrapper} {...rest}>
      {steps.map((step, index) => (
        <ConnectionStep
          key={step}
          text={step}
          isActive={index + 1 == currentStep}
          currentStep={index + 1}
          isCompleted={index + 1 < currentStep}
        />
      ))}
    </Flex>
  );
};

interface ConnectionStepProps extends Pick<Props, 'currentStep'> {
  text: string;
  isActive: boolean;
  isCompleted: boolean;
}
const ConnectionStep: FC<ConnectionStepProps> = ({
  text,
  isActive,
  isCompleted,
  currentStep,
}) => {
  let styles = '';
  if (isActive) {
    styles = s.activeStep;
  } else if (isCompleted) {
    styles = s.completedStep;
  }
  return (
    <section className={[styles, s.stepWrapper].join(' ')}>
      {isCompleted ? (
        <img src={StepDoneIcon} alt="step done icon" />
      ) : (
        <Text className={[s.stepText].join(' ')}>
          Step {currentStep}. {text.toUpperCase()}
        </Text>
      )}
    </section>
  );
};
